import { render, staticRenderFns } from "./statRoomlist.vue?vue&type=template&id=3afbce92&scoped=true&"
import script from "./statRoomlist.vue?vue&type=script&lang=js&"
export * from "./statRoomlist.vue?vue&type=script&lang=js&"
import style0 from "./statRoomlist.vue?vue&type=style&index=0&id=3afbce92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afbce92",
  null
  
)

export default component.exports